import React from "react";
import Axios from "@/js/common/Axios";
import Modal from "@/js/common/ui/modal/Modal";
import DialogTitleBar from "@/js/system/common/DialogTitleBar";
import PreViewFile from "../../budgetFileBox/PreViewFile";
interface Props {
    mbrasId        : string; // 조합원 ID
    mbrasAtchFileId: string; // 첨부파일 ID
    mbrFileNm      : string; // 파일명(real file name)
}

const MemberFileView = ( {mbrasId, mbrasAtchFileId, mbrFileNm}: Props) => {
    const [previewModalOpen, setPreviewModalOpen] = React.useState(false);
    const [blobUrl, setBlobUrl] = React.useState("");
    const [fileName, setFileName] = React.useState("");

    const getFileExtension = (name: string): string => {
        const lastDot = name.lastIndexOf(".");
        return lastDot >= 0 ? name.substring(lastDot + 1).toLowerCase() : "";
    };

    const isPreviewableFile = (name: string) => {
        const ext = getFileExtension(name);
        return ["pdf", "jpg", "jpeg", "png", "gif", "bmp"].includes(ext);
    };

    const handlePreview = () => {
        Axios.dataAccess({
            url: "system/mbras/new/download-mbras-file.do",
            methodType: "get",
            responseType: "blob",
            disableDownloadOnBlob: true,
            paramData: {
                mbrasId: mbrasId,
                mbrasAtchFileId: mbrasAtchFileId,
            },
            onSuccessFn: (res: any) => {
                setBlobUrl(res.blobUrl);
                setFileName(res.fileName || mbrFileNm);
                setPreviewModalOpen(true);
            },
        });
    };

    return (
        <>
            <div className="dpFlx aiC" style={{width: "100%", maxWidth: "100%"}}>
                <span
                    className="pl5 Pretendard-Medium fs14 ls07 fc454545 pr20 csP tdU-hover fc5C93FF-hover"
                    style={{
                        flex: 1,
                        minWidth: 0,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                    }}
                    title={mbrFileNm}
                    onClick={() => {
                        Axios.dataAccess({
                            url: "system/mbras/new/download-mbras-file.do",
                            methodType: "get",
                            responseType: "blob",
                            paramData: {
                                mbrasId: mbrasId,
                                mbrasAtchFileId: mbrasAtchFileId
                            }
                        });
                    }}
                >
                    {mbrFileNm}
                </span>

                {isPreviewableFile(mbrFileNm) && (
                    <button
                        type="button"
                        className="SpoqaHanSansNeo-Medium fs11 ls075"
                        style={{
                            height: "24px",
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                            backgroundColor: "#FFFFFF",
                            color: "#666666",
                            padding: "0 7px",
                            cursor: "pointer",
                            whiteSpace: "nowrap",
                            flexShrink: 0,
                            marginLeft: "auto",
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                            handlePreview();
                        }}
                    >
                        미리보기
                    </button>
                )}
            </div>

            <Modal modalOpen={previewModalOpen} dim={true} visible={true} width={940}
                titleEl={<DialogTitleBar title="파일 미리보기" />} onCloseFunc={() => setPreviewModalOpen(false)}
            >
                <PreViewFile blobUrl={blobUrl} fileName={fileName} />
            </Modal>
        </>
    )
}

export default MemberFileView;
